import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=70c34707&scoped=true&"
import script from "./NavbarComponent.vue?vue&type=script&lang=js&"
export * from "./NavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=70c34707&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c34707",
  null
  
)

export default component.exports